import StorageService from "@/services/StorageService";
import { SET_USER, SET_ACCOUNT_DETAILS, SET_USER_TOKEN } from "@/store/types";
import { getUsersList, getUserById, editUser } from "@/api/UserApi";
import { isLogged, setLogged, getUser, removeToken } from "@/utils/auth/user";
import Vue from "vue";
import router from "@/router";

export default {
  namespaced: true,
  state: {
    user: getUser(),
    accountDetails: {},
    token: isLogged(),
    data: null,
    error: null,
  },
  getters: {
    getUser(state) {
      return state.user;
    },
    getAccountDetails(state) {
      return state.accountDetails;
    },
    getUserList(state) {
      return state;
    },
  },
  mutations: {
    [SET_USER]: (state, payload) => {
      state.user = payload;
      state.data = payload;
    },
    [SET_ACCOUNT_DETAILS]: (state, payload) => {
      state.accountDetails = payload;
    },
    [SET_USER_TOKEN]: (state, payload) => {
      state.token = payload;
    },
  },
  actions: {
    authenticateUser({ commit }, payload) {
      setLogged(payload.token);
      commit(SET_USER_TOKEN, payload.token);
    },
    setUser({ commit }, user) {
      // Set the user in the vuex-store
      commit(SET_USER, user);

      // Set the user in localstorage to be accessed on page refreshes.
      StorageService.store("user", user);
    },
    setAccountDetails({ commit }, account) {
      commit(SET_ACCOUNT_DETAILS, account);
    },
    logoutUser({ commit }) {
      Vue.prototype.$confirm.require({
        message:
          "Are you sure you want to logout from the portal? Logging out will log you out from all your sessions of this browser",
        header: "Warning",
        icon: "pi pi-exclamation-triangle text-danger",
        accept: () => {
          commit(SET_USER, {});
          StorageService.clear();
          StorageService.store("user", null);
          removeToken();
          router.push({ name: "login" });
        },
        reject: () => {
          //callback to execute when user rejects the action
        },
      });
    },
    getUsersList({ dispatch }, lazyParams) {
      return new Promise((resolve, reject) => {
        getUsersList(lazyParams)
          .then((response) => {
            dispatch("setUserList", response.data);
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    setUserList({ commit }, userList) {
      commit(SET_USER, userList);
    },
    getUserById(stat, id) {
      return new Promise((resolve, reject) => {
        getUserById(id)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    editUser(stat, data) {
      const user = {
        username: data.user.uname,
        first_name: data.user.fname,
        last_name: data.user.lname,
        middle_name: data.user.mname,
        email: data.user.email,
        address: data.user.address,
        date_of_birth: this.$options.filters.date(data.user.dob),
        status: 1,
      };
      return new Promise((resolve, reject) => {
        editUser(user, data.id)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
